const { hostInfo } = require("./envUtils");

let isChina =
  process.env.PLATFORM_ENV === "url"
    ? hostInfo.isChinaHost
    : process.env.IS_CHINA == "1";

// Load environment-specific
const env =
  process.env.PLATFORM_ENV === "url"
    ? hostInfo.platformEnv
    : process.env.PLATFORM_ENV;

const isSentryEnabled = process.env.ENABLE_SENTRY == "1"; // keeping sentry enabled flag same as before as jenkins dictates its value
const setIsChina = _isChina => {
  isChina = _isChina;
};

const getIsChina = () => {
  return isChina;
};

const withRuntimeCommons = config => {
  config.isChina = isChina;
  config.env = env;
  config.isSentryEnabled = isSentryEnabled;
  config.setIsChina = setIsChina;
  config.getIsChina = getIsChina;

  return config;
};

module.exports = {
  isChina, // NOTE: primitive snapshot — use config.getIsChina() for runtime-updated value
  withRuntimeCommons,
};
